import React from "react";
import assign from "object-assign";
import classnames from "classnames";
import GrComponentFactory from "../gr_component_factory";


const renderTooltips = (spec) => {
  if (spec.trackCurrentSlide === null || !spec.trackTooltips) {
    return null;
  }
  const slides = [];
  const postCloneSlides = [];

  React.Children.forEach(spec.trackTooltips, (elem, index) => {
    const childElement = React.cloneElement(elem, assign({
      currentSlide: spec.trackCurrentSlide,
      slideIndex: index },
        elem.props));

    const trackElement = (<div>{childElement}</div>);
    //let slideStyle = getSlideStyle(assign({slideIndex: index}, spec));
    //let slideClasses = getSlideClasses(assign({slideIndex: index}, spec));
    let offset = index - spec.trackCurrentSlide + 1;
    if (offset < 0) {
      offset += spec.trackTooltips.length;
    }
    const style = {
      left: spec.trackSlideWidth * offset,
      position: "relative",
    };
    let classname = "";
    if (index === spec.displayTooltipAtIndex) {
      classname = "gr-carousel-tooltipAudioBook__visible";
    }
    else {
      classname = "gr-carousel-tooltipAudioBook__hidden";
    }
    if (index < (spec.trackCurrentSlide + spec.trackSlidesToShow) && index >= spec.trackCurrentSlide) {

      slides.push(React.cloneElement(trackElement, {
        key: `original${  index}`,
        "data-index": index,
        className: classnames(classname),
        style: assign(style, elem.props.style || {}),
      }));
    }

    if (spec.trackWrapAround) {
      if ((spec.trackCurrentSlide + spec.trackSlidesToShow >= spec.trackSlidesCount) && (index < spec.trackCurrentSlide + spec.trackSlidesToShow - spec.trackSlidesCount)) {
        const key =  index + spec.trackSlidesCount;
        postCloneSlides.push (React.cloneElement(trackElement, {
          key: `cloned${  key}`,
          "data-index": key,
          className: classnames(classname),
          style: assign(style, elem.props.style || {}),
        }));
      }
    }
  });

  return [...slides, ...postCloneSlides];
};

export default GrComponentFactory.createClass({

  displayName: "TooltipTrack",

  propTypes: {
    trackCurrentSlide: React.PropTypes.number,
    trackWrapAround: React.PropTypes.bool,
    trackTooltips: React.PropTypes.array,
    trackSlidesCount: React.PropTypes.number,
    trackSlidesToScroll: React.PropTypes.number,
    trackSlidesToShow: React.PropTypes.number,
    trackSlideContainerWidth: React.PropTypes.number,
    trackStyle: React.PropTypes.object,
    displayTooltipAtIndex: React.PropTypes.number,
    trackSlideWidth: React.PropTypes.number,
  },

  render () {
    const slides = renderTooltips(this.props);
    return (
        <div className={classnames("tooltip-track")} style={this.props.trackStyle}>
          {slides}
        </div>
    );
  },
});
